import { Link } from "react-router-dom";
import { useEffect } from "react";

export default function NotFound() {
  useEffect(() => { document.title = "Page not found — SuhaniEdge"; }, []);
  return (
    <div className="min-h-screen grain flex items-center justify-center px-6" data-testid="not-found">
      <div className="text-center">
        <p className="font-heading text-[8rem] leading-none font-bold text-brand-gradient">404</p>
        <h1 className="mt-2 font-heading text-2xl font-semibold text-white">This page took a detour.</h1>
        <p className="mt-3 text-slate-400">The page you're looking for doesn't exist or has moved.</p>
        <Link to="/" data-testid="notfound-home-btn" className="mt-8 inline-flex items-center gap-2 rounded-full bg-brand hover:bg-brand-light text-white font-semibold px-8 py-4 transition-colors">
          Back to SuhaniEdge
        </Link>
      </div>
    </div>
  );
}
